import { render, staticRenderFns } from "./CollectionCreatorHelpHeader.vue?vue&type=template&id=5c4a8ff1"
import script from "./CollectionCreatorHelpHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCreatorHelpHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports